import { observable } from 'mobx';

import Message from './Message';


class MessageList {
  @observable messages = [];

  get currentMessage() {
    if (this.empty) {
      return new Message('', 'default');
    }
    return this.messages[0];
  }

  get length() {
    return this.messages.length;
  }

  get empty() {
    return this.messages.length === 0;
  }

  closeCurrent() {
    this.messages.remove(this.currentMessage);
  }

  push(message) {
    this.messages.push(message);
  }
}


export const messageList = new MessageList();


export default MessageList;
